<template>
	<div class="home-center">
		<div class="center">
			<div class="block">
				<!-- 轮播图 -->
				<div class="home-top-carousel">
					<div v-if="currentFlag" class="w" style="height: 55vh">
						<img :src="imgServeUrl + carousels[currentIndex].image" @click="imgCarouselsChage()" style="width: 100%; height: 100%; cursor: pointer" />
					</div>
					<el-carousel v-else height="55vh" style="" class="w" :autoplay="!currentFlag" @change="handleCarouselChange">
						<el-carousel-item v-for="(item, index) in carousels" :key="index" style="width: 100%; text-align: center">
							<img @click="carouselFunc(item)" :src="imgServeUrl + item.image" style="width: 100%; height: 100%; cursor: pointer" />
						</el-carousel-item>
					</el-carousel>
					<div class="home-carousel-card w">
						<div
							style="cursor: pointer"
							v-for="(item, index2) in carousels"
							:key="index2"
							:class="{ active: currentIndex == index2 }"
							:title="item.title"
							@click="setCurrentIndex(index2, item)"
						>
							{{ item.title }}
						</div>
						<!-- <div v-for="item in carousels"> {{ item.title }}</div> -->
					</div>
				</div>

				<div class="bgbom">
					<!-- 数据信息卡片 -->
					<div class="w">
						<div class="newsBg">
							<div class="newsBgLeft">{{ $t('system.infoData.OngoingNews') }}</div>
							<div class="news-scroll-container">
								<vue-seamless-scroll :data="newsList" :class-option="classOption" class="warp">
									<div v-for="(item, index) in newsList" :key="index" class="news-item" @click="NewsClik(item)">
										<div class="news-list-wrapper">
											<div class="newsBgmiddle">
												{{ item.title }}
											</div>
											<div class="newsBgRight">
												<div v-for="(itemT, index) in item.createTime.split(' ')[0]" :key="index" class="digit">
													{{ itemT }}
												</div>
											</div>
										</div>
									</div>
								</vue-seamless-scroll>
							</div>
						</div>
					</div>

					<div class="release">
						<div class="w" style="display: flex">
							<div style="flex: 1">
								<div class="releaseTitle">
									<h5>{{ $t('system.infoData.lastNew') }}</h5>
									<div class="releaseMore" @click="clickMore()">{{ $t('system.infoData.more') }}</div>
								</div>
								<div class="releaseContain">
									<div class="Rcenter">
										<div v-for="(item, index) in newsList" :key="index" style="" @click="moreNewFunc(item)">
											<div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 500px; font-size: 18px; line-height: 50px" :title="item.title">
												{{ item.title }}
											</div>
											<div style="font-size: 16px; rgba(248, 248, 248,0. 6)">{{ item.createTime }}</div>
										</div>
									</div>
								</div>
							</div>
							<div style="width: 400px; padding: 0 0 0 15px">
								<div class="releaseContainRight">
									<div v-for="(item, index3) in relateData1" :key="index3" class="releaseContainRightDiv" @click="relateDataFunc(item)">
										<img :src="require('@/assets/imgs/newHome/jtR.png')" alt="" width="20" class="imgJt" />
										<img :src="item.src" alt="" width="385" />
										<div>{{ item.title1 }}</div>
										<span>{{ item.title2 }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ballAnimation from '@/utils/smallballmotion'
import { mapGetters } from 'vuex'
import ServiceCardData from '../assets/homeServiceData'
import SolutionData from '../assets/homeSolutionData'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
	components: { vueSeamlessScroll },
	data() {
		return {
			currentObj: '',
			imgServeUrl: window.dataManage.imgDev,
			carouselTime: '',
			currentFlag: false,
			classOption: {
				// step: 1,
				singleHeight: 100,
				waitTime: 2000
			},
			newsList: [
				// {
				// 	title: "中国探月工程地面应用系统公开发布嫦娥一号500米分辨率全月数字高程模型数据",
				// 	time: "20231001 12:00:00"
				// },
			],
			relateData: {
				src: require('@/assets/imgs/newHome/data-img.png')
			},

			relateData1: [
				{
					src: require('@/assets/imgs/newHome/kp.png'),
					title1: this.$t('system.infoData.Roam'),
					title2: this.$t('system.infoData.MoonandPlanets'),
					path: 'https://moon.bao.ac.cn/Moon/plviewer/moon.html'
				},
				{
					src: require('@/assets/imgs/newHome/hx.png'),
					title1: this.$t('system.infoData.Lunar'),
					title2: this.$t('system.infoData.MoonandPlanets'),
					path: 'https://moon.bao.ac.cn/Mars/plviewer/mars.html'
				},
				{
					src: require('@/assets/imgs/newHome/yq.png'),
					title1: this.$t('system.infoData.PopularScience'),
					title2: this.$t('system.infoData.MoonandPlanets'),
					path: 'https://moon.bao.ac.cn/web/zhmanager/dmt'
				}
			],
			relateTile: [],
			itemTime: '20220207',
			currentIndex: 0, // 当前轮播图的索引
			ballsInfo: [],
			carousels: [],
			carousel: [
				{ id: 1, backgroundImg: require('../assets/imgs/home/carousel1.png') },
				{ id: 2, backgroundImg: require('../assets/imgs/home/carousel2.png') }
			],
			StatisticsCard: [
				{
					id: 1,
					icon: require('../assets/imgs/home/newicon1.png'),
					title: '卫星资源',
					num: '0'
				},
				{
					id: 2,
					icon: require('../assets/imgs/home/newicon2.png'),
					title: '产品数量',
					num: '0'
				},
				{
					id: 2,
					icon: require('../assets/imgs/home/newicon3.png'),
					title: '需求发布',
					num: '0'
				},
				{
					id: 3,
					icon: require('../assets/imgs/home/newicon4.png'),
					title: '入驻单位',
					num: '0'
				}
			],

			serviceTab: 0,
			serviceCard: ServiceCardData[0],

			solutionTab: 0,
			solutionCard: SolutionData[0],

			ecoPartners: [
				{ logo: require('../assets/imgs/home/eco-partners/htht.png'), alt: '', toUrl: '' },
				{ logo: require('../assets/imgs/home/eco-partners/cgwx.png'), alt: '', toUrl: '' },
				{ logo: require('../assets/imgs/home/eco-partners/obt.png'), alt: '', toUrl: '' }
			]
		}
	},
	created() {
		//获取轮播图
		this.homeSwiper()
		// 获取新闻信息
		this.newsListFunc()
	},
	mounted() {},
	watch: {},
	computed: {},

	methods: {
		relateDataFunc(item) {
			if (item.title1 == '科普教育' || item.title1 == 'Popular Science') {
				const pathUrl = window.location.origin + '/#/remoteSensingpedia'
				window.open(pathUrl, '_blank')
			} else {
				window.open(item.path, '_blank')
			}
		},
		imgCarouselsChage() {
			if (this.currentObj != '' && this.currentObj.externalLinks != '') {
				window.open(this.currentObj.externalLinks, '_blank')
			} else {
				alert('暂无数据！')
				return
			}
		},
		carouselFunc(item) {
			if (item.externalLinks) {
				window.open(item.externalLinks, '_blank')
			} else {
				alert('暂无数据！')
				return
			}
		},
		NewsClik(item) {
			this.$router.replace({ path: '/HomeInfo', query: { type: item.newsType, id: item.id, foreignId: item.foreignId } })
		},
		moreNewFunc(item) {
			this.$router.replace({ path: '/HomeInfo', query: { type: item.newsType, id: item.id } })
		},
		clickMore(item) {
			this.$router.replace({ path: '/HomeList', query: { type: 2 } })
			// this.$router.push({ name: 'buyerCenter', query: { type: 'datagongao' } })
		},
		handleCarouselChange(item, index) {
			// console.log(this.carousels.length)
			this.currentIndex = 0
			// 这个方法可能不会被调用，因为 <el-carousel> 没有 @change 事件
			// 如果 Element UI 将来添加了此事件，你可以在这里更新 currentIndex
			if (index + 1 != this.carousels.length) {
				this.currentIndex = index + 1
			} else {
				this.currentIndex = 0
			}
		},
		setCurrentIndex(index, item) {
			this.currentIndex = index
			this.tempIndex = index
			this.currentFlag = true
			this.currentObj = item
			clearInterval(this.carouselTime)
			this.carouselTime = setInterval(() => {
				this.currentFlag = false
				this.currentIndex = 0
				this.currentObj = ''
			}, 3000)
			// 注意：这里不会自动触发轮播图跳到对应项目，因为 <el-carousel> 没有提供这样的 API
			// 你可能需要自己实现一个跳转到指定项目的方法，或者接受这种不同步的行为
		},
		//获取轮播图
		async homeSwiper() {
			let res = await this.$http.get(this.$const.common.homeSwiper)
			if (res.code === 200) {
				// this.carousels = res.data.slice(0, 5)
				this.carousels = res.data
			}
		},
		async newsListFunc() {
			let res = await this.$http.get(this.$const.common.newsListURL)
			if (res.code === 200) {
				// this.newsList = res.rows.reverse()
				this.newsList = res.rows
			}
		},

		merchantSettle() {
			// 商家入驻
			this.$router.push({ path: '/MerchantSettled' })
		},
		switchServiceTab(index) {
			this.serviceTab = index
			this.serviceCard = ServiceCardData[index]
		},
		switchSolutionTab(index) {
			this.solutionTab = index
			this.solutionCard = SolutionData[index]
		}
		// productServicePage(type) {
		// 	if (type === 'PlatformRules') type = 'InvestmentRules'
		// 	this.$router.push({
		// 		name: 'AdvisoryCenter',
		// 		query: {
		// 			type
		// 		}
		// 	})
		// }
	}
}
</script>

<style lang="scss" scoped>
$width: 1400px;
.home-center {
	> .center {
		position: relative;
		// padding: 0px 0px 15px 0px;
		background-size: cover;
		background: url('~@/assets/imgs/newHome/bgBom.png');
		background-size: auto 100%;
		.bgbom {
		}
		> .block {
			overflow: hidden;

			.home-top-carousel {
				position: relative;
				padding: 0px 0px 15px 0px;
				// background-size: cover;
				// background: url('~@/assets/imgs/newHome/bg2.png');
				// background-size: auto 100%;

				/deep/ .el-carousel__indicators--horizontal {
					display: none;
				}

				.home-carousel-card {
					display: flex;
					justify-content: center;
					margin-top: 1%;
					gap: 1%;
					width: 70%;
					> div {
						margin: auto 0;
						height: 60px;
						color: #b4b4b4;
						background: rgba(255, 255, 255, 0.1);
						box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.5);
						// border-bottom: 1px solid #005CFF;

						line-height: 60px;
						text-align: center;
						width: 20%;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.active {
						color: #ffde00;
						border-bottom: 1px solid #ffde00;
					}
				}
			}

			.newsBg {
				width: 100%;
				height: 50px;
				overflow: hidden;
				background-size: cover;
				background: url('~@/assets/imgs/newHome/fag.png');
				// background-size: 100% 100%;
				background-position-x: 48%;
				// padding: 0 15px;
				background-repeat: no-repeat;
				display: flex;
				align-items: center;
				gap: 1%;
				justify-content: space-between;

				.newsBgLeft {
					width: 169px;
					height: 32px;
					background-image: url('~@/assets/imgs/newHome/bg6.png');
					color: #fff;
					font-size: 18px;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					padding-left: 10px;
				}

				.news-container {
					height: 200px;
					/* 设置容器的高度 */
					overflow: hidden;
					position: relative;
					display: inline-block;
				}

				.scroll-wrapper {
					position: absolute;
					top: 100%;
					/* 初始位置在容器外部上方 */
					width: 100%;

					/* 向上滚动动画 */
				}

				.news-scroll-container {
					flex: 1;

					height: 100%;
					/* 设置滚动容器的高度 */
					overflow: hidden;
					/* 隐藏超出容器的内容 */

					position: relative;
					// display: flex;
					// flex-direction: column;
					// gap: 10px;
					animation: scrollUp 10s linear infinite;
				}

				.news-item {
					height: 50px;
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.news-list-wrapper {
					// position: absolute;
					width: 100%;
					height: 100%;
					// animation: scrollUp 10s infinite;
					/* 上下滚动动画 */
					display: flex;
					justify-content: center;
					align-items: center;
				}

				// @keyframes scrollUp {
				// 	from {
				// 		transform: translateY(0);
				// 	}

				// 	to {
				// 		transform: translateY(-100%);
				// 	}
				// }

				.newsBgmiddle {
					display: inline-block;
					flex: 1;
					font-family: MicrosoftYaHeiUI;
					font-size: 16px;
					color: #f1f1f1;
					line-height: 24px;
					text-align: left;
					font-style: normal;
					cursor: pointer;
				}

				.warp {
					// height: 100px;
					width: 100%;
					margin: 0 auto;
					height: 100%;
					overflow: hidden;

					a {
						display: block;
						height: 130px;
						line-height: 30px;
						display: flex;
						justify-content: space-between;
						font-size: 15px;
					}
				}

				.newsBgRight {
					display: flex;

					.digit {
						display: inline-block;
						width: 20px;
						/* 可以根据需要调整宽度 */
						height: 20px;
						/* 可以根据需要调整高度 */
						line-height: 20px;
						/* 使数字垂直居中 */
						text-align: center;
						background-color: #4878ca;
						color: white;
						/* 数字颜色设为白色 */
						font-size: 16px;
						/* 可以根据需要调整字体大小 */
						margin: 1px;
						/* 数字之间的默认缝隙 */
						font-family: Quartz-Regular;
					}

					.digit:nth-child(4) {
						margin-right: 3px;
						/* 增加第四个数字右边的缝隙 */
					}

					.digit:nth-child(6) {
						margin-right: 3px;
						/* 增加第四个数字右边的缝隙 */
					}
				}
			}

			.release {
				width: 100%;
				// background: linear-gradient(to bottom, #d4e2f8 0%, #f0f5ff 10px, #f0f5ff 10px, #f0f5ff 100%);
				// background: #F0F5FF;
				// padding: 1%;
				margin-top: 10px;
				.releaseTitle {
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 28px;
					color: #f1f1f1;
					line-height: 37px;
					text-align: left;
					font-style: normal;
					display: flex;
					justify-content: space-between;

					.releaseMore {
						width: 60px;
						color: #2969d7;
						font-family: MicrosoftYaHeiUI;
						font-size: 18px;
						line-height: 24px;
						cursor: pointer;
					}
				}

				.releaseContain {
					display: flex;
					justify-content: space-between;
					gap: 1%;
					padding-top: 2%;

					.Rleft {
						min-width: 320px;
					}

					.Rcenter {
						flex: 1;
						font-family: MicrosoftYaHeiUI;
						justify-content: space-between;
						font-size: 18px;
						color: #ccc;
						line-height: 24px;
						text-align: left;
						font-style: normal;
						// overflow-y: auto;
						overflow: hidden;
						height: 300px;
						> div {
							min-height: 36px;
							display: flex;
							// flex-direction: column;
							// justify-content: space-around;
							padding-left: 2%;
							cursor: pointer;
							// font-weight: 550;
							line-height: 40px;
							flex-direction: row;
							justify-content: space-between;
							align-items: anchor-center;
						}

						> div:active,
						> div:hover {
							// background: #dfe6f6;
							background: linear-gradient(90deg, rgba(42, 158, 210, 0.3) 0%, rgba(42, 158, 210, 0) 100%);
							box-shadow: inset 0px -1px 0px 0px rgba(238, 238, 238, 0.2);
							color: #fff;
						}
					}
				}
			}
			.releaseContainRight {
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.releaseContainRightDiv {
					position: relative;
					padding-bottom: 10px;
					color: #fff;
					cursor: pointer;
					.imgJt {
						position: absolute;
						top: 50px;
						right: 10%;
					}
					> div {
						position: absolute;
						top: 30px;
						left: 45%;
						font-size: 20px;
						color: #ffffff;
						line-height: 27px;
						text-align: left;
						font-style: normal;

						// display: flex;
						> div:nth-child(1) {
							font-family: MicrosoftYaHeiUI;
							font-size: 16px;
							top: 20px;

							opacity: 0.6;
						}
					}
					span {
						position: absolute;
						top: 60px;
						left: 45%;
						opacity: 0.6;
						font-size: 16px;
						color: #ffffff;
					}
				}
			}
			.home-statistic-card {
				width: 100%;
				display: flex;
				position: absolute;

				.home-statistic-card-item {
					width: 31.5%;
					height: 160px;
					background-repeat: no-repeat;
					background-size: cover;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-grow: 1;
					cursor: pointer;
					column-gap: 18px;

					img {
						width: 100px;
						height: 100px;
						margin: 0 15px;
						vertical-align: middle;
					}

					.statistic-card-title {
						color: black;
						flex: 1;
						font-size: 20px;
					}

					.statistic-card-num {
						color: #2569f2;
						font-size: 36px;
						font-weight: 700;
						font-family: Nexa-XBold;
					}
				}

				> .home-statistic-button {
					align-self: center;
					margin-left: 35px;

					> button {
						background-color: #2569f2;
						transition: 0.2s;

						&:hover {
							opacity: 0.8;
						}

						img {
							margin-left: 4px;
							vertical-align: middle;
						}
					}
				}
			}

			.home-section-header {
				margin-top: 60px;
				margin-bottom: 40px;
				font-size: 40px;

				> .home-section-header-cn {
					color: #2569f2;
					font-size: 32px;
					font-weight: 600;
					letter-spacing: 6px;
				}

				> .home-section-header-en {
					margin-top: -6px;
					color: rgba($color: #005cff, $alpha: 0.2);
					font-size: 50px;
					font-family: BebasNeueCyrillic;
					letter-spacing: -6px;
				}
			}

			> .home-product-service {
				width: 100%;
				background-size: cover;
				background-color: #f5f5f5;
				overflow: hidden;

				> .home-service-tabs {
					display: flex;
					align-items: center;
					margin-bottom: 30px;

					> .home-service-tab-item {
						flex: 1;
						position: relative;
						margin-right: 2px;
						padding: 16px 0;
						text-align: center;
						background-image: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
						transition: 0.3s;
						cursor: pointer;

						&:hover {
							background-image: linear-gradient(180deg, #e0eaff 0%, #f5f5f5 100%);
						}

						&.is-active {
							background-image: linear-gradient(180deg, #e0eaff 0%, #f5f5f5 100%);

							&::before {
								content: '';
								position: absolute;
								top: 6px;
								left: 6px;
								border: 6px solid transparent;
								border-top-color: #2569f2;
								border-left-color: #2569f2;
							}

							> .service-item-title {
								color: black;
								font-weight: 700;
							}
						}

						&:last-child {
							margin-right: 0;
						}

						> .service-item-title {
							color: #666666;
							font-size: 20px;
						}

						> .service-item-desc {
							color: #999999;
						}
					}
				}

				> .home-solution-content {
					> .home-solution-container {
						position: relative;
						width: 100%;

						> img {
							width: 100%;
						}

						> .home-solution-desc {
							position: absolute;
							top: 50%;
							right: 60px;
							transform: translateY(-50%);

							> .home-solution-text {
								width: 360px;
								margin-bottom: 30px;
								color: white;
								font-size: 24px;
								line-height: 36px;
								letter-spacing: 1.5px;
								user-select: none;
							}

							> button {
								padding: 9px 20px;
								background-color: rgba(255, 255, 255, 0.15);
								border: 1px solid white;
								border-radius: 4px;
								color: white;
								font-size: 18px;
								transition: 0.2s;
								cursor: pointer;

								&:hover {
									background-color: rgba(255, 255, 255, 0);
								}

								> img {
									margin-left: 8px;
									vertical-align: middle;
								}
							}
						}
					}
				}
			}

			> .home-platform-advantage {
				width: 100%;
				height: 100vh;
				padding-top: 60px;
				background-image: url('../assets/imgs/home/earth.png');
				background-repeat: no-repeat;
				background-size: cover;
				background-position-y: 35%;
			}

			> .home-eco-partner {
				width: 100%;
				padding-top: 60px;
				background-image: url('../assets/imgs/home/newEcoPBG.png');
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;

				> .eco-partner-container {
					padding-bottom: 64px;

					> .eco-partner-row {
						display: flex;
						align-items: center;
						justify-content: center;
						flex-wrap: wrap;
						margin-bottom: -32px;
					}

					.box1,
					.box2,
					.box3 {
						width: 18%;
						height: 225px;
						overflow: hidden;

						@media (max-width: 1024px) {
							width: 120px;
							height: 150px;
						}
					}

					.box1 {
						transform: rotate(120deg);
						margin-left: 35px;

						> .box2 {
							transform: rotate(-60deg);

							> .box3 {
								transform: rotate(-60deg);
								background: white;

								> img {
									position: absolute;
									top: 50%;
									left: 50%;
									width: 100%;
									max-height: 90px;
									transform: translate(-50%, -50%);
								}
							}
						}
					}
				}
			}
		}
	}
}

.ball {
	background: url('~@/assets/image/ballbak.png') no-repeat;
	background-size: cover;
}

.Service-container {
	margin: 0 auto;
	position: relative;
}

@media screen and (max-width: 1600px) {
	.tabBody {
		width: 1100px;
	}

	.Service-container {
		margin: 0 auto;
		position: relative;
	}
}

@media screen and (max-width: 1200px) {
	.tabBody {
		width: 900px;
	}

	.Service-container {
		margin: 0 auto;
		position: relative;
		height: 86%;
	}
}

.solutions-list {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	row-gap: calc(#{$width} * 0.03);

	> li {
		width: 33%;
		height: 400px;
		padding-right: 20px;
		-webkit-transition: 0.55s;
		transition: 0.55s;

		&:nth-child(3n) {
			padding-right: 0;
		}
	}

	.solutions-card {
		display: block;
		position: relative;
		height: 100%;
		background-size: cover;
		background-position: 0;
		border-radius: 6px;
		color: #fff;
		overflow: hidden;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

		> .solutions-card-cover {
			background-size: 100% 100%;
			background-position: 0;
		}
	}
}

.solutions-card-cover,
.solutions-card-cover-mask {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	-webkit-transition: 0.65s;
	transition: 0.65s;
}

.Service-container {
	margin: 0 auto;
	position: relative;
}

.solutions-card-text {
	position: absolute;
	top: 0;
	left: 40px;
	right: 20px;
	height: auto;
	-webkit-transition: 0.55s;
	transition: 0.55s;
	margin-top: 300px;
	-webkit-transform: translateY(0);
	transform: translateY(0);
}

.solutions-card-title {
	position: relative;
	font-size: 24px;
	text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
	line-height: 24px;

	&::after {
		content: '——';
		display: block;
		margin-top: 12px;
	}
}

.solutions-card-text p {
	font-size: 0.8vw;
	line-height: 22px;
	opacity: 0;
	-webkit-transition: 0.2s;
	transition: 0.2s;
}

.solutions-card-more {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	font-size: 14px;
	line-height: 20px;
	-webkit-transition: 0.2s;
	transition: 0.2s;
	opacity: 0;
	cursor: pointer;

	> i {
		padding-top: 2px;
		font-size: 14px;
	}
}

.solutions-list li:hover .solutions-card-cover-mask {
	background: rgba(0, 0, 0, 0.46);
}

.solutions-list li:hover .solutions-card-text {
	top: 50%;
	-webkit-transform: translateY(-50%);
	transform: translateY(-50%);
	margin-top: 0 !important;
}

.solutions-list li:hover .solutions-card-more,
.solutions-list li:hover .solutions-card-text p {
	opacity: 1;
	-webkit-transition: 0.65s 0.1s;
	transition: 0.65s 0.1s;
}

.solutions-list li:hover .solutions-card-cover {
	-webkit-filter: blur(6px);
	filter: blur(6px);
}
</style>